<button
  *ngIf="portalRules.length > 0"
  mat-stroked-button
  [matMenuTriggerFor]="portalMenu"
  class="mr-2"
>
  <mat-icon>public</mat-icon>
  {{ 'patient-details.appointment.portals-menu-button' | translate }}
</button>
<mat-menu #portalMenu="matMenu">
  <a
    *ngFor="let rule of portalRules"
    mat-menu-item
    [attr.href]="rule.portalSystem?.url"
    target="_blank"
    rel="noreferrer"
  >
    [{{ rule.insurance.clinicCarrierName }}] {{ rule.portal.name }}
  </a>
</mat-menu>
